import { createContext } from "react";

const OutgoingCertificateContext = createContext(false);

export default OutgoingCertificateContext;
